// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--hFXqe","link":"link--_ZFmw","link_adjustment":"link_adjustment--aFhEY","fadeSlideUp":"fadeSlideUp--lHfbD"};